<script>
import firebase from 'firebase/compat/app';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
let uuid = require('uuid');
import { functions } from '../../main';
import {
  getStorage,
  ref,
  uploadString,
  uploadBytes,
  getDownloadURL,
} from 'firebase/storage';
import OnboardingPopup from './OnboardingPopup.vue';
export default {
  props: ['isProfileVerified'],
  components: {
    vueDropzone: vue2Dropzone,
    LinkPayVerify: () => import('@/components/LinkPayVerify.vue'),
    OnboardingPopup: OnboardingPopup,
  },
  data() {
    return {
      uploadingNewProfilePic: false,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 200,
        uploadMultiple: false,
        // maxFilesize: 0.5,
        addRemoveLinks: true,
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag Images or Click Here</p>
          `,
        headers: { 'My-Awesome-Header': 'header value' },
      },
      e1: 1,
      email: '',
      loading: false,
      file: null,
      UpdatedEmail: '',
      Imgdialog: false,
      startDialog: true,
      verifyDialog: false,
      preference: '',
      dialog1: false,
      hasMobile: true,
      dontShareNumber: false,
      shareNumber: false,
      preferenceDialog: false,
      mobileDialog: true,
      on: '',
      attrs: '',
      imageUrl: '',
      images: [],
      images: null,
      authUser: null,
      //  user: null,
      userDataFromDB: null,
      uploaded: 0,
      mobile: '',
      suburb: '',
      uploaded1: 0,
      uploaded2: 0,
      terms: '',
      verifyEmail: '',
      POAimages: [],
      POAimageUrls: [],
      on: '',
      attrs: '',
      IDimages: [],
      phone: null,
      email: '',
      IDimageUrls: [],
      Selfimages: [],
      SelfimageUrls: [],
      credit: '',
      loading: false,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 200,
        uploadMultiple: false,
        // maxFilesize: 0.5,
        addRemoveLinks: true,
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag Images or Click Here</p>
          `,
        headers: { 'My-Awesome-Header': 'header value' },
      },
      dialog: false,
      rules: {
        required: (value) => !!value || 'Required.',
        min: (v) => v.length >= 8 || 'Min 8 characters',
        emailMatch: () => "The email and password you entered don't match",
      },
    };
  },
  watch: {
    // if( profileVerified  true) {
    //   this.startDialog == true;
    // }
  },
  mounted() {
    // console.log('MOUNNNNNNTED:', this.$store.getters.user);
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      this.authUser = user;
      if (user) {
        this.displayName = user.displayName;
        // if (this.photoURL) {
        //   this.photoURL = user.photoURL;
        // }
        this.email = user.email;

        firebase
          .firestore()
          .collection('users')
          .doc(user.uid)
          .get()
          .then((snap) => {
            this.userDataFromDB = snap.data();
            if (this.userDataFromDB && this.userDataFromDB.verified) {
              this.$emit('profileVerified', true);
              this.startDialog == true;
            }

            // if (
            //   this.userDataFromDB.suburb == null ||
            //   this.userDataFromDB.suburb == undefined ||
            //   this.userDataFromDB.suburb == ''
            // ) {
            //   this.hasMobile = false;
            //   this.mobileDialog = true;
            // } else {
            //   this.hasMobile = true;
            //   this.mobileDialog = false;
            // }
          });
      }
    });
    var vm = this;
    // firebase.auth().onAuthStateChanged(function(user) {
    //   if (user) {
    //     vm.user = user;
    //     vm.name = firebase.auth().currentUser.displayName;
    //     vm.email = vm.user.email;
    //     vm.photoURL = vm.user.photoURL;
    //     vm.userId = vm.user.uid;
    //   }
    // });
  },

  computed: {
    verified() {
      this.$store.getters.user.verified;
    },
    error() {
      return this.$store.getters.error;
    },
    formIsValid() {
      return (
        this.uploaded > 0 &&
        this.uploaded1 > 0 &&
        this.uploaded2 > 0 &&
        // this.phone.length > 8 &&
        this.terms === 'true' &&
        this.credit === 'true'
      );
    },
    linkedGoogle() {
      return !!this.authUser.providerData.find(
        (provider) => provider.providerId === 'google.com'
      );
    },
    linkedFacebook() {
      return !!this.authUser.providerData.find(
        (provider) => provider.providerId === 'facebook.com'
      );
    },
    linkedPassword() {
      return !!this.authUser.providerData.find(
        (provider) => provider.providerId === 'password'
      );
    },
  },

  methods: {
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async remove() {
      this.uploaded > 0 ? this.uploaded-- : (this.uploaded = 0);
    },

    async remove1() {
      this.uploaded1 > 0 ? this.uploaded1-- : (this.uploaded1 = 0);
    },

    async remove2() {
      this.uploaded2 > 0 ? this.uploaded2-- : (this.uploaded2 = 0);
    },

    async afterComplete(upload) {
      this.uploaded++;
      //this.loading = true;
    },

    async afterComplete1(upload) {
      this.uploaded1++;
      //this.loading = true;
    },

    async afterComplete2(upload) {
      this.uploaded2++;
      //this.loading = true;
    },

    async updateProfile() {
      this.uploadingNewProfilePic = true;
      this.loading = true;
      if (this.imageUrl && this.imageUrl != '') {
        let user = firebase.auth().currentUser;
        var storageRef = await firebase
          .storage()
          .ref('userProfiles/' + user.uid);
        storageRef.putString(this.imageUrl, 'data_url');
        storageRef.getDownloadURL().then((url) => {
          user.updateProfile({
            photoURL: url,
          });
          this.uploadingNewProfilePic = false;
          // TODO
          this.Imgdialog = false;
          this.$router.go('/dashboard');
          this.loading = false;
        });
      }
    },

    saveUsersProfile({}, payload) {
      // Get the File
      const file = payload[0];
      const extension = file.name.split('.').pop();
      const uploadDate = new Date();
      const fileName = `${
        firebaseAuth.currentUser.uid
      }-${uploadDate.toDateString()}.${extension}`;
      firebaseStorage
        .ref(`users/profile/${fileName}`)
        .put(file)
        .then((res) => {})
        .catch((err) => {});
    },

    linkGoogle() {
      const provider = new firebase.auth.GoogleAuthProvider();
      this.authUser
        .linkWithPopup(provider)
        .catch((error) => alert('🤕' + error.message));
    },
    linkFacebook() {
      const provider = new firebase.auth.FacebookAuthProvider();
      this.authUser
        .linkWithPopup(provider)
        .catch((error) => alert('🤕' + error.message));
    },
    unlinkGoogle() {
      this.authUser.unlink('google.com');
    },
    unlinkFacebook() {
      this.authUser.unlink('facebook.com');
    },

    onPickFile() {
      this.$refs.fileInput.click();
    },

    onFilePicked(event) {
      const files = event.target.files;
      const filename = files[0].name;
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file!');
      }
      const fileReader = new FileReader();
      fileReader.addEventListener('load', () => {
        this.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.imageUrl = files[0];
    },
    uploadImageAndContinue() {
      var files = this.$refs.imgDropZone.getAcceptedFiles();
      var arr = [];
      for (var i in files) {
        arr.push(files[i].dataURL);
      }
      this.POAimageUrls = arr;
    },
    uploadImageAndContinue1() {
      var files = this.$refs.imgDropZone1.getAcceptedFiles();
      var arr = [];
      for (var i in files) {
        arr.push(files[i].dataURL);
      }
      this.IDimageUrls = arr;
    },
    uploadImageAndContinue2() {
      var files = this.$refs.imgDropZone2.getAcceptedFiles();
      var arr = [];
      for (var i in files) {
        arr.push(files[i].dataURL);
      }
      this.SelfimageUrls = arr;
    },

    resetPassword() {
      const auth = firebase.auth();

      auth
        .sendPasswordResetEmail(auth.currentUser.email)
        .then(() => {
          alert('Check your email to reset the password!');
          //     //     this.User = {
          //     //       email: ""
          //     //     };
        })
        .catch((error) => {
          alert(error);
        });
      // firebase
      //   .auth()
      //   .sendPasswordResetEmail(auth.currentUser.email)
      //   .then(() => {
      //     alert("Check your email to reset the password!");
      //     //     this.User = {
      //     //       email: ""
      //     //     };
      //   })
      //   .catch(error => {
      //     alert(error);
      //   });
    },

    async uploadImagesAndGetUrls() {
      return new Promise(async (resolve, reject) => {
        var arr = [];
        for (var i in this.POAimageUrls) {
          var POAimageUrl = uuid.v1();
          try {
            const file = this.POAimageUrls[i];
            const storage = getStorage();
            console.log('poa', file);
            const imageRef = ref(storage, `users/POA/${POAimageUrl}.png`);
            const snapshot = await uploadBytes(imageRef, file, 'data_url');
            var downloadURL = await getDownloadURL(snapshot.ref);
            arr.push({ src: downloadURL });
            console.log(arr);
          } catch (error) {
            console.log(error);
          }
        }
        console.log(arr);
        resolve(arr);
      });
    },

    async uploadImagesAndGetUrls1() {
      return new Promise(async (resolve, reject) => {
        var arr = [];
        for (var i in this.SelfimageUrls) {
          var SelfimageUrl = uuid.v1();
          try {
            const file = this.SelfimageUrls[i];
            const storage = getStorage();
            const imageRef = ref(storage, `users/Selfies/${SelfimageUrl}.png`);
            const snapshot = await uploadString(imageRef, file, 'data_url');
            var downloadURL = await getDownloadURL(snapshot.ref);
            arr.push({ src: downloadURL });
            console.log(arr);
          } catch (error) {
            console.log(error);
          }
        }
        console.log(arr);
        resolve(arr);
      });
    },

    async uploadImagesAndGetUrls2() {
      return new Promise(async (resolve, reject) => {
        var arr = [];
        for (var i in this.IDimageUrls) {
          var IDimageUrl = uuid.v1();
          try {
            const file = this.IDimageUrls[i];
            const storage = getStorage();
            console.log('id', file);
            const imageRef = ref(storage, `users/IDs/${IDimageUrl}.png`);
            const snapshot = await uploadString(imageRef, file, 'data_url');
            var downloadURL = await getDownloadURL(snapshot.ref);
            arr.push({ src: downloadURL });
            console.log(arr);
          } catch (error) {
            console.log(error);
          }
        }
        console.log(arr);
        resolve(arr);
      });
    },

    sendEmail() {
      const callable = functions.httpsCallable('verificationEmail');
      const self = this;
      return callable({
        email: self.user.email,
      }).then((res) => console.log(res));
    },

    updateEmail() {
      this.authUser.updateEmail(this.UpdatedEmail);
      this.$store.dispatch('logout');
      this.$router.push('/');
    },

    async uploadMobile() {
      this.loading = true;

      const verificationData = {
        suburb: this.suburb,
        phone: this.phone,
      };
      this.$store.dispatch('updateUser', verificationData);
      Toast.fire({
        title: 'Account updated successfully!',
      });
      this.loading = false;

      this.hasMobile = true;
      this.mobileDialog = false;
      this.startDialog = true;
    },

    async uploadVerification() {
      this.loading = true;
      var POAimages = await this.uploadImagesAndGetUrls();
      var IDimages = await this.uploadImagesAndGetUrls1();
      var Selfimages = await this.uploadImagesAndGetUrls2();
      const verificationData = {
        credit: this.credit,
        terms: this.terms,
        // phone: this.phone,
        dontShareNumber: this.dontShareNumber,
        POAimages,
        IDimages,
        Selfimages,
      };
      this.$store.dispatch('verifyUser', verificationData);
      Toast.fire({
        title: 'Account preferences updated successfully!',
      });
      this.loading = false;
      this.verifyDialog = false;
      this.verified = true;
      this.sendEmail();
      this.$emit('profileVerified', true);
    },

    updatePreferences() {
      const verificationData = {
        shareNumber: this.shareNumber,
      };
      this.$store.dispatch('updatePreferences', verificationData);
      this.preferenceDialog = false;
    },

    onLogout() {
      this.$store.dispatch('logout');
      this.$router.push('/');
    },
  },
};
</script>
<template>
  <div>
    <v-card
      style="
        border: 1px solid #dddddd !important;
        border-radius: 12px !important;
      "
      outlined
      class="pa-5 ml-n1"
    >
      <v-row>
        <v-col sm="12">
          <v-avatar
            v-bind="attrs"
            v-on="on"
            @click="Imgdialog = true"
            outline
            size="130"
          >
            <v-img
              v-if="this.$store.state.user.avatar"
              :src="this.$store.state.user.avatar"
            ></v-img>

            <svg
              v-else
              viewBox="0 0 32 32"
              xmlns="http://www.w3.org/2000/svg"
              style="fill: currentcolor"
              aria-hidden="true"
              role="presentation"
              focusable="false"
            >
              <path
                d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
              ></path>
            </svg>
          </v-avatar>

          <!-- <p>{{ this.$store.state.user.avatar }}</p> -->

          <!-- <v-dialog
            style="border-radius: 12px !important; overflow: hidden"
            v-model="Imgdialog"
            width="550"
          >
            <v-card
              style="border-radius: 12px !important; overflow: hidden"
              class="pa-3 text-center"
            >
              <v-card-title
                style="
                  padding: 0px 24px !important;
                  font-size: 1em !important;
                  line-height: 1.43;
                "
                class="text-center black--text"
              >
                <v-icon small color="black" @click="Imgdialog = false"
                  >mdi-close</v-icon
                >
                <p class="my-3 ml-auto mr-auto">Edit Profile Picture</p>
              </v-card-title>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12">
                  <v-avatar size="153">
                    {{ authUser }}
                    <v-img
                      :src="imageUrl || authUser.photoURL"
                      v-if="imageUrl || authUser.photoURL"
                    ></v-img>
                    <svg
                      viewBox="0 0 32 32"
                      xmlns="http://www.w3.org/2000/svg"
                      style="fill: currentcolor"
                      aria-hidden="true"
                      role="presentation"
                      focusable="false"
                    >
                      <path
                        d="m16 .7c-8.437 0-15.3 6.863-15.3 15.3s6.863 15.3 15.3 15.3 15.3-6.863 15.3-15.3-6.863-15.3-15.3-15.3zm0 28c-4.021 0-7.605-1.884-9.933-4.81a12.425 12.425 0 0 1 6.451-4.4 6.507 6.507 0 0 1 -3.018-5.49c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5a6.513 6.513 0 0 1 -3.019 5.491 12.42 12.42 0 0 1 6.452 4.4c-2.328 2.925-5.912 4.809-9.933 4.809z"
                      ></path>
                    </svg>
                  </v-avatar>

                  <input
                    class="mt-4 ml-2"
                    ref="fileInput"
                    type="file"
                    accept="image/*"
                    @change="onFilePicked"
                  />
                </v-col>
              </v-row>
              <div class="grid">
                <v-btn
                  elevation="8"
                  width="7rem"
                  color="secondary"
                  type="submit"
                  value="Save Changes"
                  class="ebtn"
                  :loading="uploadingNewProfilePic"
                  :disabled="uploadingNewProfilePic"
                  @click="updateProfile()"
                  >Save</v-btn
                >
              </div>
            </v-card>
          </v-dialog> -->

          <!-- <v-icon
            @click="Imgdialog = true"
            style="margin-top: 100px"
            class="ml-n7"
            >fas fa-edit</v-icon
          > -->

          <p
            class="pt-2"
            :class="[$vuetify.breakpoint.mdAndUp ? 'h6' : 'subtitle-1']"
          >
            Hi
            {{ this.$store.state.user.firstName }}
            <svg
              height="20px"
              width="20px"
              aria-hidden="true"
              focusable="false"
              data-prefix="fad"
              data-icon="face-smile-beam"
              class="svg-inline--fa fa-face-smile-beam fa-w-16 mt-2 mb-n1"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <g class="fa-group">
                <path
                  class="fa-secondary"
                  fill="#B22AF0"
                  d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM120 223.4C123.3 181.3 152.2 152 175.1 152c23.86 0 52.79 29.25 56.06 71.38C232.8 232 221.2 235.3 217.1 227.9l-9.566-17C199.9 197.3 188.4 189.3 176 189.3c-12.23 0-23.73 8-31.48 21.62l-9.445 17C130.7 235.3 119.3 231.9 120 223.4zM370.8 346.3C342.3 380.4 300.4 399.1 256 399.1s-86.3-19.6-114.8-53.73c-13.56-16.38 10.98-36.75 24.54-20.5C188.2 352.6 221 367.9 256 367.9s67.81-15.42 90.21-42.17C359.8 309.5 384.4 330 370.8 346.3zM376.1 227.9l-9.445-17c-7.75-13.62-19.25-21.62-31.48-21.62c-12.35 0-23.86 8-31.48 21.62l-9.566 17c-4.117 7.375-15.67 3.95-14.94-4.55C283.3 181.3 312.3 152 336 152c23.86 0 52.76 29.25 56.03 71.38C392.7 232 381.1 235.3 376.1 227.9z"
                ></path>
                <path
                  class="fa-primary"
                  fill="#F8955B"
                  d="M120 223.4C123.3 181.3 152.2 152 175.1 152c23.86 0 52.79 29.25 56.06 71.38C232.8 232 221.2 235.3 217.1 227.9l-9.566-17C199.9 197.3 188.4 189.3 176 189.3c-12.23 0-23.73 8-31.48 21.62l-9.445 17C130.7 235.3 119.3 231.9 120 223.4zM376.1 227.9l-9.445-17c-7.75-13.62-19.25-21.62-31.48-21.62c-12.35 0-23.86 8-31.48 21.62l-9.566 17c-4.117 7.375-15.67 3.95-14.94-4.55C283.3 181.3 312.3 152 336 152c23.86 0 52.76 29.25 56.03 71.38C392.7 232 381.1 235.3 376.1 227.9z"
                ></path>
              </g>
            </svg>
          </p>
          <div v-if="verified == true">
            <div class="mr-auto ml-auto">
              <p style="font-size: small">Account verified</p>
              <svg
                :style="
                  $vuetify.breakpoint.xsOnly
                    ? 'height: 10px; width: 10px;'
                    : '' && $vuetify.breakpoint.smAndDown
                    ? 'height: 30px; width: 30px;'
                    : 'height: 30px; width: 30px;' &&
                      $vuetify.breakpoint.mdAndUp
                    ? 'height: 18px; width: 18px;'
                    : 'height: 12px; width: 12px;'
                "
                aria-hidden="true"
                focusable="false"
                data-prefix="fad"
                data-icon="user-shield"
                class="svg-inline--fa fa-user-shield fa-w-20"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 640 512"
              >
                <g class="fa-group">
                  <path
                    class="fa-secondary"
                    fill="#7B1FA2"
                    d="M224 256c70.7 0 128-57.31 128-128S294.7 0 224 0C153.3 0 96 57.31 96 128S153.3 256 224 256zM320.6 310.3C305.9 306.3 290.6 304 274.7 304H173.3C77.61 304 0 381.7 0 477.4C0 496.5 15.52 512 34.66 512H413.3c3.143 0 5.967-1.004 8.861-1.789C369.7 469.8 324.1 400.3 320.6 310.3z"
                  ></path>
                  <path
                    class="fa-primary"
                    fill="#F29E4D"
                    d="M622.3 271.1l-115.1-45.01c-4.125-1.629-12.62-3.754-22.25 0L369.8 271.1C359 275.2 352 285.1 352 295.1c0 111.6 68.75 188.8 132.9 213.9c9.625 3.75 18 1.625 22.25 0C558.4 489.9 640 420.5 640 295.1C640 285.1 633 275.2 622.3 271.1zM496 462.4V273.2l95.5 37.38C585.9 397.8 530.6 446 496 462.4z"
                  ></path>
                </g>
              </svg>
            </div>
          </div>

          <p :class="[$vuetify.breakpoint.mdAndUp ? 'caption' : 'caption']">
            {{ authUser && authUser.email ? authUser.email : '' }}
          </p>
          <v-responsive>
            <v-dialog v-model="verifyDialog" scrollable max-width="300px">
              <v-card style="border-radius: 12px">
                <div class="grid mt-8">
                  <v-row>
                    <v-card class="mr-5" style="border-radius: 12px">
                      <base-img
                        :src="require('@/assets/logos/icon1.svg')"
                        class="mx-auto pa-6"
                        contain
                        width="32"
                      />
                    </v-card>
                    <v-img
                      class="mt-5 ma-2"
                      :style="
                        $vuetify.breakpoint.xsOnly
                          ? 'height: 10px; width: 10px;'
                          : '' && $vuetify.breakpoint.smAndDown
                          ? 'height: 30px; width: 30px;'
                          : 'height: 30px; width: 30px;' &&
                            $vuetify.breakpoint.mdAndUp
                          ? 'height: 18px; width: 18px;'
                          : 'height: 12px; width: 12px;'
                      "
                      :src="
                        require('@/assets/fontawesome/arrow-right-arrow-left-regular.svg')
                      "
                    />
                    <v-card class="ml-5" style="border-radius: 12px">
                      <base-img
                        :src="require('@/assets/logos/stitch-s.svg')"
                        class="mx-auto pa-6"
                        contain
                        width="32"
                      />
                    </v-card>
                  </v-row>
                  <v-divider></v-divider>
                  <v-card-title class="text-center mt-4"
                    >Verify with Stitch</v-card-title
                  >

                  <v-card-text class="text-body-2 text-center">
                    For your own safety and the safety of fellow Strappers you
                    are required to verify your profile before any bookings can
                    be finalized.
                  </v-card-text>

                  <v-btn class="text-app" small>Learn more about Stitch</v-btn>

                  <v-divider></v-divider>

                  <v-card-text class="text-body-2 text-center">
                    On the next Screen you will be taken through Stitchs
                    verification which will ask you to link your bank account.
                    This is a one time process and will create a wallet with us
                    to be used for refunds and credit will also enable one click
                    payments going forward
                  </v-card-text>
                  <link-pay-verify></link-pay-verify>
                </div>
              </v-card>
            </v-dialog>
          </v-responsive>
          <v-btn
            color="secondary"
            outlinedFF
            elevation="10"
            class="mt-3"
            @click="resetPassword"
            rounded
            small
            >Change Password</v-btn
          >

          <v-btn
            to="/edit-profile"
            color="secondary"
            outlinedFF
            elevation="10"
            class="mt-3"
            rounded
            small
            >Edit profile</v-btn
          >

          <br />
          <v-btn
            color="secondary"
            outlined
            elevation="10"
            class="mt-3"
            @click="$router.push('/reviews').catch((err) => {})"
            rounded
            small
          >
            Ratings & Reviews</v-btn
          >
        </v-col>
      </v-row>
    </v-card>

    <!-- <onboarding-popup /> -->
  </div>
</template>

<style>
.grid {
  display: grid;
  place-items: center;
}

.input {
  border-radius: 12px;
}

.heading {
  font-size: 22px !important;
  line-height: 26px !important;
  color: rgb(34, 34, 34) !important;
  font-weight: 600 !important;
  margin-bottom: 8px !important;
}
.hero-button {
  padding: 1rem 4rem;
  border-radius: 100rem;
  color: white;
  width: 10rem;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}

.hero-button:hover {
  width: 11rem;
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
}

.dz-max-files-reached {
  background-color: red;
}

.ebtn {
  display: inline-block;
  background: #7fc4a1;
  padding: 0.8rem 1.8rem;
  width: 25px;
  margin-top: 2rem;
  cursor: pointer;
  border-radius: 14px;
  font-weight: 700;
  transition: 0.5s;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
}

.ebtn:hover {
  opacity: 0.8;
  border-radius: 18px;
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.4);
  transform: translateY(-7px);
  color: #7552b9;
  background-color: #7552b9;
}

.Card {
  transition: 0.5s;
  border-radius: 25px;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.9);
  transition: all 0.3s ease 0s;
  background-color: #81abfc;
}

.Card:hover {
  box-shadow: 0px 15px 20px rgba(46, 229, 157, 0.8);
  border-radius: 15px;
  transform: translateY(-7px);
  background-color: #7f90bc;
}
</style>
